import { Link } from 'react-router-dom';
import { newReleaseComics, comicArticles } from '@/mocks/comics';

export default function LatestSection() {
  const latest = [...comicArticles]
    .sort((a, b) => new Date(b.updatedDate).getTime() - new Date(a.updatedDate).getTime())
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm">持续更新的韩漫章节，追更不停歇</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-3 p-3 rounded-lg bg-background-50 border border-secondary-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-16 h-20 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} 最新更新 - 韩漫网`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-foreground-900 font-bold text-sm line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {comic.title}
                </h4>
                <p className="text-foreground-400 text-xs mt-1 line-clamp-1">{comic.author}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-accent-500 text-xs font-medium whitespace-nowrap">第{comic.chapters}话</span>
                  <span className="text-foreground-300 text-xs">{comic.updatedDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {newReleaseComics.length > 0 && (
          <div className="mt-8 p-4 md:p-6 rounded-xl bg-accent-100/50 border border-accent-200/50">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-sparkling-line text-accent-600"></i>
              </div>
              <h3 className="text-foreground-900 font-bold font-heading">新鲜上架</h3>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {newReleaseComics.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/article/${comic.id}`}
                  className="flex items-center gap-3 group"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-200 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-add-line"></i>
                  </div>
                  <div>
                    <p className="text-foreground-900 text-sm font-medium group-hover:text-primary-600 transition-colors whitespace-nowrap">{comic.title}</p>
                    <p className="text-foreground-400 text-xs">{comic.author}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}